export default __webpack_public_path__ + "static/media/STLCoveringforProceedings.329f3275.pdf";